export const RecoActions={
    CLEAR_SPEAKERS:"CLEAR_SPEAKERS",
    SAVE_DISTRICTS:"SAVE_DISTRICTS",
    SAVE_SPEAKERS:"SAVE_SPEAKERS",
    SAVE_RECTYPES:"SAVE_RECTYPES",
    SAVE_RECMETHODS:"SAVE_RECMETHODS"
}